import * as Notifications from "expo-notifications";
import { Platform } from "react-native";

/** Marks a local re-present so we do not schedule again in a loop. */
export const LOCAL_FOREGROUND_FLAG = "__localForeground";

/**
 * Android channel for a push `data.type`. Must match `ensureAndroidChannels`.
 */
function channelIdForType(type: unknown): string {
    return type === "absence_reminder" ? "absence_reminder" : "default";
}

/**
 * Shows a local notification while the app is foregrounded on Android.
 *
 * Remote FCM often reaches JS (RNFB / expo listeners) without painting a system
 * banner. Scheduling with `trigger: null` uses the same channel and tap payload.
 */
export async function presentAndroidForegroundPush(input: {
    title?: string | null;
    body?: string | null;
    data?: Record<string, unknown>;
}): Promise<void> {
    if (Platform.OS !== "android") {
        return;
    }

    const data = { ...(input.data ?? {}) };
    if (data[LOCAL_FOREGROUND_FLAG] === "1") {
        return;
    }

    const title = input.title?.trim() || undefined;
    const body = input.body?.trim() || undefined;
    if (!title && !body) {
        return;
    }

    await Notifications.scheduleNotificationAsync({
        content: {
            title,
            body,
            data: {
                ...data,
                [LOCAL_FOREGROUND_FLAG]: "1",
            },
            sound: true,
            channelId: channelIdForType(data.type),
        },
        trigger: null,
    });
}
